
import { useState } from 'react';
import BookingModal from './BookingModal';
import ContactModal from './ContactModal';

export default function CTA() {
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <>
      <section className="relative py-24 overflow-hidden">
        {/* Background */}
        <div className="absolute inset-0 bg-midnight-navy"></div>
        <div className="absolute inset-0 bg-gradient-to-br from-wealth-gold/10 via-transparent to-emerald-insight/10"></div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-5xl font-serif font-bold text-white mb-6">
            Ready to Build <span className="text-wealth-gold">Smarter Operations?</span>
          </h2>
          <p className="text-xl text-soft-silver mb-10 leading-relaxed">
            Let's identify where intelligent systems can create the biggest impact in your business.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => setShowBookingModal(true)}
              className="px-8 py-4 bg-wealth-gold text-midnight-navy text-base font-semibold rounded-lg hover:bg-wealth-gold/90 transition-all whitespace-nowrap cursor-pointer"
            >
              Schedule a Consultation
            </button>
            <button
              onClick={() => setShowContactModal(true)}
              className="px-8 py-4 bg-transparent border-2 border-white text-white text-base font-semibold rounded-lg hover:bg-white hover:text-midnight-navy transition-all whitespace-nowrap cursor-pointer"
            >
              Contact Our Team
            </button>
          </div>
        </div>
      </section>

      {showBookingModal && <BookingModal onClose={() => setShowBookingModal(false)} />}
      {showContactModal && <ContactModal onClose={() => setShowContactModal(false)} />}
    </>
  );
}
